export const formatTasksCountSummary = (
  overdue: number,
  dueToday: number
): string =>
  [
    overdue > 0 ? `${overdue} en retard` : null,
    dueToday > 0 ? `${dueToday} aujourd'hui` : null
  ]
    .filter((part) => part !== null)
    .join(' · ')
